import _ from 'lodash';
import angular from 'angular';
import Logger from '../../../shared/logger';

export const TalentService = (Restangular) => {
    const postTalents = function ({ talentIDs, isListView = false, skipCache = false }) {
        if (_.isArray(talentIDs) && _.isEmpty(talentIDs)) {
            return Promise.resolve({ result: [] });
        }

        const searchParams = {
            talentIDs,
            skipCache,
            isListView,
        };

        return Restangular.all('talent')
            .all('search')
            .post(searchParams)
            .catch(error => Logger.error(error));
    };

    const getTalent = function (talentId) {
        return Restangular.one('talent', talentId)
            .get('')
            .catch(error => Logger.error(error));
    };

    const postTalentForCreation = function (data) {
        return Restangular.all('talent')
            .all('talentForCreation')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const postTalentForCreationByTalentId = function (talentId) {
        return Restangular.all('talent')
            .one('talentForCreation', talentId)
            .post('')
            .catch(error => Logger.error(error));
    };

    const deleteTalent = function (talentId) {
        return Restangular.all('talent')
            .customOperation('remove', '', {}, { 'Content-Type': 'application/json' }, { talentId })
            .catch(error => Logger.error(error));
    };

    const postTalentForInstantCreation = function (data) {
        return Restangular.all('talent')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const importOnlyFromLinkedInUrl = function (data) {
        return Restangular.all('talent')
            .all('importOnlyFromLinkedInUrl')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getImportFromLinkedInUrlStatus = function (data) {
        return Restangular.all('talent')
            .all('getImportFromLinkedInUrlStatus')
            .post(data);
    };

    const claimCandidateImportedByLinkedInUrl = function (data) {
        return Restangular.all('talent')
            .all('claimCandidateImportedByLinkedInUrl')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const putTalent = function (talentId, data) {
        return Restangular.one('talent', talentId)
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const putTalentJobSeeker = function (talentId, data) {
        return Restangular.one('talent', talentId)
            .all('jobSeeker')
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const searchTalentsByCandidateIds = function (body) {
        return Restangular.all('talent')
            .all('searchByCandidates')
            .post(body)
            .catch(error => Logger.error(error));
    };

    return {
        postTalents,
        postTalentForCreation,
        postTalentForCreationByTalentId,
        deleteTalent,
        postTalentForInstantCreation,
        importOnlyFromLinkedInUrl,
        getImportFromLinkedInUrlStatus,
        claimCandidateImportedByLinkedInUrl,
        putTalent,
        putTalentJobSeeker,
        getTalent,
        searchTalentsByCandidateIds,
    };
};

angular.module('TALENYA-FE')
    .factory('TalentService', TalentService);

